<template>
  <v-menu nudge-bottom="10" nudge-left="20" left>
    <template v-slot:activator="{ attrs, on }">
      <v-btn plain text rounded :ripple="false" v-bind="attrs" v-on="on">
        <v-icon color="black"> mdi-account-circle-outline </v-icon>
      </v-btn>
    </template>

    <v-card tile flat :elevation="0" max-width="200px">
      <v-layout wrap justify-center pa-2>
        <v-flex xs12 text-center>
          <span
            style="
              font-family: sofiaProRegular;
              font-size: 14px;
              color: #000000;
            "
          >
            Welcome
          </span>
        </v-flex>
        <v-flex xs12 text-center>
          <router-link to="/myProfile" style="text-decoration: none">
            <span v-if="appLogin">
              <span
                style="
                  font-family: sofiapromedium;
                  letter-spacing: 1px;
                  font-size: 16px;
                  color: #1e1b1b;
                  cursor: pointer;
                "
              >
                <!-- {{ appUser.firstname }} {{ appUser.lastname }} -->
              </span>
              <span
                style="
                  font-family: sofiapromedium;
                  letter-spacing: 1px;
                  font-size: 16px;
                  color: #1e1b1b;
                  cursor: pointer;
                "
                v-if="appUser.username"
                >{{ appUser.username }}</span
              ><br />
              <!-- <span v-if="appUser.guest">
              {{ appUser.guest.name }}
            </span>
            <span v-else>
              <span v-if="appUser.user">
                {{ appUser.user.email.slice(0, 16) }}
                <span v-if="appUser.user.email.length > 18">...</span>
              </span>
            </span> -->
            </span>
          </router-link>
          <span
            style="
              font-family: robotoregular;
              letter-spacing: 1px;
              font-size: 14px;
              color: #1e1b1b;
              cursor: pointer;
            "
            v-if="(appType == 'Customer')"
          >
            <router-link
              style="text-decoration: none; color: black"
              to="/myOrder"
            >
              My Orders</router-link
            >
          </span>
        </v-flex>
        <!-- <v-flex xs12 py-0 text-center>
          <router-link to="/Bookings">
            <span
              v-if="appLogin"
              style="
                font-family: sofiaProLight;
                letter-spacing: 1px;
                font-size: 12px;
                color: #1e1b1b;
              "
            >
              My Bookings
            </span>
          </router-link>
        </v-flex> -->
        <!-- <v-flex xs12 v-if ="appUser.userRole == 'Customer'"
        >
          <v-btn
            color="#0000001f"
            outlined
            tile
            small
            :ripple="false"
          >
          MY Order
          </v-btn>
        </v-flex> -->
        <v-flex xs12 pt-2 text-center>
          <v-btn
            color="#0000001f"
            outlined
            tile
            small
            :ripple="false"
            @click="appLogout"
          >
            <span
              style="
                font-family: sofiaProRegular;
                font-size: 14px;
                color: black;
              "
            >
              LOGOUT
            </span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </v-menu>
</template>
<script>
export default {
  data() {
    return {
      user: {},
    };
  },
  computed: {
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
    appUser() {
      return this.$store.state.userData;
    },
     appType() {
      return this.$store.state.userRole;
    },
  },

  methods: {
    appLogout() {
      this.$store.commit("logoutUser", true);
    },
  },
};
</script>